import React from "react";
import { memo } from "react";
import { scameTimeMeasure } from "../assets/constants/constants";

export const FrameTime = ({ timing1, n, playbackLength, hms, isTopController, frameTimeLimit, frameCount }) => {
  let framN = Math.floor(n / frameTimeLimit) * frameTimeLimit;
  let splitupsecs = scameTimeMeasure;
  if (framN > 0 && n > 0 && playbackLength > 0) {
    var minsandsec = (framN / splitupsecs).toFixed(2);
    var minsLength = playbackLength / minsandsec;
    var secsLength =
      (playbackLength / minsandsec).toFixed(2) * (minsandsec % 1).toFixed(2);
  }

  return (
    <>
      <div
        className={isTopController ? `seconsTimelinetopcontroller` : `seconsTimeline`}
        style={{ textAlign: "left", fontSize: isTopController ? '10px' : '21px' }}
        key={`timing_seconds_List0`}
      >
        <span>
          <sup>|</sup>
          <sub style={{ fontSize: "10px" }}>00:00</sub>
        </span>
      </div>
      {timing1
        ? timing1.map((item, index) => {
          return (
            ((item % splitupsecs == 0) || item == framN) && (
              <div
                className={isTopController ? `seconsTimelinetopcontroller` : `seconsTimeline`}
                style={{
                  textAlign: "right",
                  marginLeft:
                    Math.floor(item / splitupsecs) == 1 ? "-23px" : "",
                  width: (item == framN && !(framN % splitupsecs > 59)) ? secsLength : minsLength,
                  fontSize: isTopController ? '10px' : '21px'
                }}
                key={`timing_seconds_List${index}`}
              >
                <span>
                  {item != framN ? (
                    <sub style={{ fontSize: "10px" }}>{hms(item)}</sub>
                  ) : (
                    <sub style={{ fontSize: "10px" }}>
                      {(framN / scameTimeMeasure)
                        .toFixed(2)
                        .toString()
                        .split(".")
                        .join(":")}
                    </sub>
                  )}
                  <sup>|</sup>
                </span>
              </div>
            )
          );
        })
        : ""}
    </>
  );
};

